import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
  Form,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const ContactSection = (props) => {
  const position = [14.083986, -87.1855946];
  const [formData, setFormData] = useState({ nombre: '', correo: '', asunto: '', mensaje: '' });
  const [formStatus, setFormStatus] = useState({ loading: false, error: null, success: null });

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, error: null, success: null });
    try {
      const API_HOST = process.env.REACT_APP_API_URL;
      const API_KEY = process.env.REACT_APP_API_KEY;
      
      const payload = {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "API": API_KEY
        },
        body: JSON.stringify(formData)
      };
      const response = await fetch(`${API_HOST}/public/contact`, payload);
        
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Error al enviar el mensaje.");
      }
      setFormStatus({ loading: false, error: null, success: "Mensaje enviado exitosamente. Nos pondremos en contacto pronto." });
      setFormData({ nombre: '', correo: '', asunto: '', mensaje: '' });
    } catch (err) {
      setFormStatus({ loading: false, error: err.message, success: null });
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id='contacto' className='py-5 bg-white'>
          <Container>
            
            {/* Formulario de Contacto */}
            <Card className='shadow border-0 rounded-4 mb-5'>
              <Card.Header
                className='py-3 px-4 rounded-top'
                style={{ backgroundColor: "#ff9800" }}
              >
                <h3 className='mb-0 text-white'>Envíanos un Mensaje</h3>
              </Card.Header>
              <Card.Body className='p-4'>
                {formStatus.success && <Alert variant="success">{formStatus.success}</Alert>}
                {formStatus.error && <Alert variant="danger">{formStatus.error}</Alert>}
                <Form onSubmit={handleContactSubmit}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" name="nombre" value={formData.nombre} onChange={handleInputChange} required placeholder="Ingresa tu nombre completo" />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Correo</Form.Label>
                        <Form.Control type="email" name="correo" value={formData.correo} onChange={handleInputChange} required placeholder="tucorreo@ejemplo.com" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3">
                    <Form.Label>Asunto</Form.Label>
                    <Form.Control type="text" name="asunto" value={formData.asunto} onChange={handleInputChange} required placeholder="¿En qué te podemos ayudar?" />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Mensaje</Form.Label>
                    <Form.Control as="textarea" rows={4} name="mensaje" value={formData.mensaje} onChange={handleInputChange} required placeholder="Escribe tu mensaje aquí..." />
                  </Form.Group>
                  <div className="text-end">
                    <Button variant="primary" type="submit" disabled={formStatus.loading} style={{ backgroundColor: "#182848", borderColor: "#182848" }}>
                      {formStatus.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Enviar Mensaje"}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>

            <Card className='shadow border-0 rounded-4'>
              <Card.Header
                className='py-3 px-4 rounded-top'
                style={{ backgroundColor: "#182848" }}
              >
                <h3 className='mb-0 text-white'>Información de Contacto</h3>
              </Card.Header>

              <Card.Body className='p-4'>
                <Row>
                  {/* Información */}
                  <Col lg={6} className='mb-4 mb-lg-0'>
                    <Row className='mb-4'>
                      <Col xs='auto'>
                        <FaPhoneAlt className='text-primary mt-1' size={20} />
                      </Col>
                      <Col>
                        <h5 className='fw-bold mb-1'>Teléfono / WhatsApp</h5>
                        <p className='mb-0'>(504) 9874-4314</p>
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col xs='auto'>
                        <FaEnvelope className='text-primary mt-1' size={20} />
                      </Col>
                      <Col>
                        <h5 className='fw-bold mb-1'>Correo electrónico</h5>
                        <p className='mb-0'>contacto@mboxhn.com</p>
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col xs='auto'>
                        <FaClock className='text-primary mt-1' size={20} />
                      </Col>
                      <Col>
                        <h5 className='fw-bold mb-1'>Horario</h5>
                        <p className='mb-0'>
                          Lunes a viernes 08:00 am - 05:00 pm
                        </p>
                        <p className='mb-0'>Sábados 09:00 am - 12:00 pm</p>
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col xs='auto'>
                        <FaMapMarkerAlt
                          className='text-primary mt-1'
                          size={20}
                        />
                      </Col>
                      <Col>
                        <h5 className='fw-bold mb-1'>Ubicación</h5>
                        <p className='mb-0'>
                          Bulevar Centro América, Edificio Corporativo C.A L5
                          Piso 3, Tegucigalpa, Honduras
                        </p>
                      </Col>
                    </Row>

                    {/* Redes Sociales */}
                    <Row>
                      <Col xs='auto'>
                        <FaShareAlt className='text-primary mt-1' size={20} />
                      </Col>
                      <Col>
                        <h5 className='fw-bold mb-1'>Redes Sociales</h5>
                        <p className='mb-0 d-flex gap-3'>
                          <a
                            href='https://instagram.com/mbox.express'
                            target='_blank'
                            rel='noreferrer'
                            className='text-decoration-none text-dark'
                          >
                            <FaInstagram size={24} />
                          </a>
                          <a
                            href='https://facebook.com/mbox.express'
                            target='_blank'
                            rel='noreferrer'
                            className='text-decoration-none text-dark'
                          >
                            <FaFacebook size={24} />
                          </a>
                          <a
                            href='https://www.tiktok.com/@mbox.expresscasillerohn'
                            target='_blank'
                            rel='noreferrer'
                            className='text-decoration-none text-dark'
                          >
                            <FaTiktok size={24} />
                          </a>
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  {/* Mapa */}
                  <Col lg={6}>
                    <div
                      className='rounded shadow-sm overflow-hidden'
                      style={{ height: "100%", minHeight: "350px" }}
                    >
                      <MapContainer
                        center={position}
                        zoom={15}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <TileLayer
                          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={position}>
                          <Popup>
                            MBox Honduras <br /> Edificio Corporativo C.A
                          </Popup>
                        </Marker>
                      </MapContainer>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
  );
};

export default ContactSection;
